import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, useMediaQuery, useTheme } from '@mui/material'
import React, { memo, useEffect, useMemo, useState } from 'react'
import Header from '../../../components/Header'
import AddIcon from '@mui/icons-material/Add';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { tokens } from '../../../theme';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import { deleteKitProduct, getKitProduct } from '../../../redux/slice/kitproduct.slice';
import DeleteIcon from '@mui/icons-material/Delete';
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import EditIcon from '@mui/icons-material/Edit';

const KitProductData = memo(({ data, columns }) => {
    return (
        <DataGrid
            rows={data}
            columns={columns}
            components={{ Toolbar: GridToolbar }}
            pageSize={5}
            rowsPerPageOptions={[5, 10]}
            getRowId={(row) => row._id}
            autoHeight
            getRowHeight={() => 'auto'}
            density="compact"
            sx={{
                "@media print": {
                    "& .MuiDataGrid-toolbarContainer": {
                        display: "none !important"
                    },
                    "& .MuiDataGrid-root": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-cell": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        color: "black !important",
                    },
                    "& .MuiDataGrid-footerContainer": {
                        color: "black !important",
                    },
                    "& .css-7ms3qr-MuiTablePagination-displayedRows": {
                        color: "black !important",
                    },
                },
                '& .MuiDataGrid-cell': {
                    py: '8px',
                },
            }}
        />
    );
});

const KitProduct = () => {
    const navigate = useNavigate()
    const theme = useTheme();
    const dispatch = useDispatch();
    const colors = tokens(theme.palette.mode);
    const kitproductData = useSelector(state => state.kitproduct.kitproduct)
    const isMobile = useMediaQuery('(max-width:500px)');

    const handleKitProduct = () => {
        navigate('/admin/add-Kit-Product');
    }
    const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
    const [deleteKitProductData, setDeleteKitProductData] = useState(null);

    const handleDelete = (id) => {
        setDeleteKitProductData(id);
        setDeleteConfirmOpen(true);
    };

    const confirmDelete = () => {
        if (deleteKitProductData) {
            dispatch(deleteKitProduct(deleteKitProductData));
            setDeleteConfirmOpen(false);
            setDeleteKitProductData(null);
        }
    }
    const cancelDelete = () => {
        setDeleteConfirmOpen(false);
        setDeleteKitProductData(null);
    }
    useEffect(() => {
        dispatch(getKitProduct())
    }, [])


    const handleEdit = (data) => {
        navigate('/admin/add-Kit-Product', { state: data });
    };
    const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
    const [openView, setOpenView] = React.useState(false);
    const [viewData, setViewData] = useState(null);

    const handleClickOpenView = () => {
        setOpenView(true);
    };
    const handleCloseView = () => {
        setOpenView(false);
    };

    const handleView = (data) => {
        handleClickOpenView();
        setViewData(data)
    }

    


    const columns = useMemo(() => [
        {
            field: 'KitName',
            headerName: 'Kit Name',
            width: 150,
            filterable: true,
        },
        {
            field: 'KitCatogory',
            headerName: 'Category',
            width: 190,
            filterable: true,
            valueGetter: (params) => {
                return params.row.KitDetails?.map(detail =>
                    detail?.categoryData?.categoryName || 'N/A'
                ).join(', ');
            },
            renderCell: (params) => (
                <div>
                    {params.row.KitDetails?.map((detail, index) => (
                        <div key={index}>{detail?.categoryData?.categoryName.length <= 25 ? detail?.categoryData?.categoryName || 'N/A' : detail?.categoryData?.categoryName + "..."}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'KitSubCatogory',
            headerName: 'Subcategory',
            width: 190,
            filterable: true,
            valueGetter: (params) => {
                return params.row.KitDetails?.map(detail =>
                    detail?.subCategoryData?.subCategoryName || 'N/A'
                ).join(', ');
            },
            renderCell: (params) => (
                <div>
                    {params.row.KitDetails?.map((detail, index) => (
                        <div key={index}>{detail?.subCategoryData?.subCategoryName.length <= 25 ? detail?.subCategoryData?.subCategoryName || 'N/A' : detail?.subCategoryData?.subCategoryName + "..."}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'KitProductName',
            headerName: 'Product Name',
            width: 250,
            filterable: true,
            valueGetter: (params) => {
                return params.row.KitDetails?.map(detail =>
                    detail?.productdata?.productName || 'N/A'
                ).join(', ');
            },
            renderCell: (params) => (
                <div>
                    {params.row.KitDetails?.map((detail, index) => (
                        <div key={index}>{detail?.productdata?.productName.length <= 38 ? detail?.productdata?.productName || 'N/A' : detail?.productdata?.productName + "..."}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'KitDiscription', headerName: 'Description', width: 400,
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.KitDetails?.map((detail, index) => (
                            <div key={index}>{detail?.productdata?.Desacription.length <= 62 ? detail?.productdata?.Desacription || 'N/A' : detail?.productdata?.Desacription ? detail?.productdata?.Desacription + "..." : 'N/A'}</div>
                        ))}
                    </div>
                );
            }
        },
        {
            field: 'KitUnit',
            headerName: 'Unit',
            width: 100,
            filterable: true,
            valueGetter: (params) => params.row.KitDetails?.map(detail => detail.KitUnit).join(', '),
            renderCell: (params) => (
                <div>
                    {/* {params.row.KitDetails?.map(detail => detail.KitUnit)
                        .map((item, index) => (
                            <div key={index}>{item}</div>
                        ))} */}

                    {params.row.KitDetails?.map((detail, index) => (
                        <div key={index}>{detail?.productdata?.unitOfMeasurement.length <= 38 ? detail?.productdata?.unitOfMeasurement || 'N/A' : detail?.productdata?.unitOfMeasurement ? detail?.productdata?.unitOfMeasurement + "..." : 'N/A'}</div>
                    ))}
                </div>
            )
        },
        {
            field: 'KitQty', headerName: 'Qty', width: 100, filterable: true,
            valueGetter: (params) => params.row.KitDetails?.map(detail => detail.KitQty).join(', '),
            renderCell: (params) => {
                return (
                    <div>
                        {params.row.KitDetails?.map(detail => detail.KitQty)
                            .join('\n')
                            .split('\n')
                            .map((item, index) => (
                                <div key={index}>{item}</div>
                            ))}
                    </div>
                );
            }
        },
        {
            field: 'Action',
            headerName: 'Action',
            width: 130,
            renderCell: (params) => (
                <>
                    <IconButton aria-label="view"
                        onClick={() => handleView(params.row)}
                    >
                        <RemoveRedEyeIcon />
                    </IconButton>
                    <IconButton aria-label="edit"
                        onClick={() => handleEdit(params.row)}
                    >
                        <EditIcon />
                    </IconButton>
                    <IconButton aria-label="delete"
                        onClick={() => handleDelete(params.row._id)}
                    >
                        <DeleteIcon />
                    </IconButton>
                </>
            )
        }
    ], []);

    return (
        <Box m="2px">
            <Header
                title="KIT PRODUCT"
                subtitle="Manage Your Kit Product Here"
            />
            <Box display="flex" justifyContent="flex-end" mb={2}>
                <Button variant="contained" color="primary" startIcon={<AddIcon />} onClick={handleKitProduct}>
                    Add Kit Product
                </Button>
            </Box>
            <Box
                height="75vh"
                sx={useMemo(() => ({
                    "& .MuiDataGrid-root": {
                        border: "none",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                        backgroundColor: colors.blueAccent[700],
                        borderBottom: "none",
                    },
                    "& .MuiDataGrid-virtualScroller": {
                        backgroundColor: colors.primary[400],
                    },
                    "& .MuiDataGrid-footerContainer": {
                        borderTop: "none",
                        backgroundColor: colors.blueAccent[700],
                    },
                    "& .MuiCheckbox-root": {
                        color: `${colors.greenAccent[200]} !important`,
                    },
                    "& .MuiDataGrid-toolbarContainer .MuiButton-text": {
                        color: `${colors.grey[100]} !important`,
                        fontSize: "13px !important",
                    },
                }), [colors])}
            >
                <KitProductData data={kitproductData} columns={columns} />
            </Box>

            <Dialog
                fullScreen={fullScreen}
                open={openView}
                onClose={handleCloseView}
                aria-labelledby="responsive-dialog-title"
                maxWidth={"sm"}
                fullWidth
            >
                <DialogTitle id="responsive-dialog-title" style={{ backgroundColor: theme.palette.background.purple, textAlign: "center", fontWeight: 'bold', fontSize: '18px' }}>
                    {"Kit Product Details"}
                </DialogTitle>
                <DialogContent style={{ backgroundColor: theme.palette.background.purple }}>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ flex: '1' }}>
                            <p style={{ backgroundColor: theme.palette.background.light, marginBottom: '2px', padding: '10px' }}><strong>Kit Name:</strong> {viewData?.KitName}</p>
                        </div>
                    </div>
                    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                        <div style={{ flex: '1' }}>
                            <h3>Kit Details:</h3>
                            <table style={{ width: '100%', borderCollapse: 'collapse', textAlign: 'center' }}>
                                <thead>
                                    <tr>
                                        <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Category</th>
                                        <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Subcategory</th>
                                        <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Product Name</th>
                                        <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Description</th>
                                        <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Unit</th>
                                        <th style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>Qty</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {viewData?.KitDetails?.map((Kit, index) => (
                                        <tr key={index}>
                                            <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                {Kit?.categoryData?.categoryName || 'N/A'}
                                            </td>
                                            <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                {Kit?.subCategoryData?.subCategoryName || 'N/A'}
                                            </td>
                                            <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                {Kit?.productdata?.productName || 'N/A'}
                                            </td>
                                            <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                {Kit?.KitDiscription || 'N/A'}
                                            </td>
                                            <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                {Kit?.KitUnit || 'N/A'}
                                            </td>
                                            <td style={{ borderBottom: `1px solid ${colors.grey[100]}`, padding: '8px' }}>
                                                {Kit?.KitQty || 'N/A'}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </DialogContent>

                <DialogActions style={{ backgroundColor: theme.palette.background.purple }}>
                    <Button autoFocus onClick={handleCloseView} style={{ color: theme.palette.text.primary }} >
                        Close
                    </Button>
                </DialogActions>
            </Dialog>

            <Dialog open={deleteConfirmOpen} onClose={cancelDelete}>
                <DialogContent>
                    Are you sure you want to delete this kit product?
                </DialogContent>
                <DialogActions>
                    <Button onClick={cancelDelete} style={{ color: theme.palette.text.primary }}>No</Button>
                    <Button onClick={confirmDelete} style={{ color: theme.palette.text.primary }}>Yes</Button>
                </DialogActions>
            </Dialog>

        </Box >
    )
}

export default KitProduct
